import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@directives/directives.module';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { UiLoginAttemptsGridComponent } from './login-attempts.grid';

const EXPORTS = [
    UiLoginAttemptsGridComponent,
];

@NgModule({
    imports: [
        CommonModule,
        UiGridModule,
        DirectivesModule,
        TranslateModule,
        MatTooltipModule,
        UiNgLetModule,
        UiDateFormatModule,
    ],
    declarations: [
        ...EXPORTS,
    ],
    exports: [
        ...EXPORTS,
    ],
})
export class UiLoginAttemptsGridModule { }
